import { RootState } from '@/redux/store';
import { Menu } from 'antd';
import { FC } from 'react';
import { useSelector } from 'react-redux';
import ThemeSwitch from './Theme';
import TopMenuAccount from './TopMenuAccount';

import './styles.scss';

const TopMenu: FC = () => {
  const themeLight = useSelector<RootState, boolean>((state) => state.app.layoutState.lightTheme);

  return (
    <Menu
      theme={themeLight ? 'light' : 'dark'}
      items={[
        {
          key: '1',
          label: <ThemeSwitch />,
        },
        {
          key: '2',
          label: <TopMenuAccount />,
        },
      ]}
      mode="horizontal"
      className="cbra-top-menu__wrapper"
    />
  );
};

export default TopMenu;
